import React from "react";

import { zipCodeInputMask } from "../../../../constants/inputMasks";
import Input from "../Input";

function InputZipCode(props) {
  return (
    <Input
      {...props}
      mask={zipCodeInputMask}
      type="tel"
    />
  );
}

export default InputZipCode;
